<template>
  <div class="tams-clock" :style="{ '--size': size + 'px' }">
    <div class="tams-clock__mark">
      <svg viewBox="0 0 200 200" class="tams-clock__svg">
        <!-- outer blue ring -->
        <circle cx="100" cy="100" r="100" fill="#016AEA" />
        <!-- white face -->
        <circle cx="100" cy="100" r="72" fill="#f2f6f9" />

        <!-- tick marks -->
        <g>
          <rect
            v-for="n in 12"
            :key="n"
            x="96.5"
            y="10"
            width="7"
            height="14"
            rx="3.5"
            fill="#f2f6f9"
            :transform="`rotate(${n * 30} 100 100)`"
          />
        </g>

        <!-- hour hand -->
        <rect
          x="97"
          y="52"
          width="6.5"
          height="52"
          rx="3"
          fill="#1A1A1A"
          :transform="`rotate(${hourDeg} 100 100)`"
        />

        <!-- minute hand -->
        <rect
          x="97.75"
          y="34"
          width="5"
          height="70"
          rx="2.25"
          fill="#1A1A1A"
          :transform="`rotate(${minuteDeg} 100 100)`"
        />

        <!-- second hand -->
        <rect
          x="99.25"
          y="24"
          width="1.5"
          height="78"
          fill="#E4372C"
          :transform="`rotate(${secondDeg} 100 100)`"
          style="z-index: 99999999;"
        />

        <!-- center pin -->
        <circle cx="100" cy="100" r="8" fill="#FFFFFF" />
        <circle cx="100" cy="100" r="6" fill="#1A1A1A" />
        <!-- <circle cx="100" cy="100" r="2.4" fill="#FFFFFF" /> -->
      </svg>

      <!--  <span class="tams-clock__wordmark">
         <span class="tams-clock__wordmark-dot" aria-hidden="true"></span>
        t<span class="text-dark">a</span><span class="bg-light">m</span>s
      </span> -->
      <div class="tams-clock-block bg-light">
        <img
          class="tams-clock__wordmark-image"
          src="../../../../public/images/tams-textt.png"
        />
      </div>
    </div>

    <hr class="tams-clock_divider" />
    <div class="tams-clock__digital" role="timer" aria-live="off">
      <span class="tams-clock__digit">{{ hh }}</span>
      <span class="tams-clock__colon">:</span>
      <span class="tams-clock__digit">{{ mm }}</span>
      <span class="tams-clock__colon">:</span>
      <span class="tams-clock__digit">{{ ss }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // pixel width/height of the clock face itself (wordmark + digital time scale with it)
    size: {
      type: Number,
      default: 200,
    },
  },

  data() {
    return {
      now: new Date(),
      rafId: null,
    };
  },

  computed: {
    // Smooth, continuous rotation (no per-second "jump") for hour + minute,
    // and an ever-moving second hand as requested.
    hourDeg() {
      const d = this.now;
      const h = d.getHours() % 12;
      return (h + d.getMinutes() / 60 + d.getSeconds() / 3600) * 30;
    },

    minuteDeg() {
      const d = this.now;
      return (
        (d.getMinutes() + d.getSeconds() / 60 + d.getMilliseconds() / 60000) * 6
      );
    },

    secondDeg() {
      const d = this.now;
      return (d.getSeconds() + d.getMilliseconds() / 1000) * 6;
    },

    hh() {
      return this.pad(this.now.getHours());
    },

    mm() {
      return this.pad(this.now.getMinutes());
    },

    ss() {
      return this.pad(this.now.getSeconds());
    },
  },

  mounted() {
    this.rafId = requestAnimationFrame(this.frame);
  },

  beforeDestroy() {
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
    }
  },

  methods: {
    frame() {
      this.now = new Date();
      this.rafId = requestAnimationFrame(this.frame);
    },

    pad(n) {
      return String(n).padStart(2, "0");
    },
  },
};
</script>

<style scoped>
.tams-clock__wordmark-image {
  width: 100%;
  height: auto;
  line-height: 0px !important;
}
.tams-clock-block {
  width: 68px;
  position: absolute;
  left: 60px;
  height: 25px;
  display: inline-block;
  z-index: 9 !important;
  padding: 0px !important;
}
.tams-clock_divider {
  width: 100%;
  border: none;
  border-top: 1px solid #dce7ef;
}
.tams-clock {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  font-family: "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  background-color: #f2f6f9;
  width: 90%;
  padding: 20px 8px 8px 8px;
  border-radius: 6px;
}

.tams-clock__mark {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  position: relative;
}

.tams-clock__svg {
  width: 110px;
  height: 110px;
  display: block;
  z-index: 9 !important;
  position: relative;
}

.tams-clock__wordmark-dot {
  display: none; /* the clock face itself doubles as the "t" tittle, per the source logo */
}

.tams-clock__digital {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-weight: 600;
  font-size: 18px;
  color: #1a1a1a;
  letter-spacing: 0.04em;
  background: #f2f6f9;
  border-radius: 8px;
  padding: 4px 12px;
  font-variant-numeric: tabular-nums;
}

.tams-clock__colon {
  color: #016aea;
  padding: 0 1px;
}
.text-dark {
  color: #1a1a1a;
}

.bg-light {
  background-color: #f2f6f9;
}
</style>
